// The INBOX page (docs/design/inbox.md §6 to §8).
//
// The page stands in blocks, top to bottom: the head of the record with
// the views and the filter row (`record.ts`, lane R), SINCE YOU LEFT with
// the DIGEST (`sinceleft.ts`, lane S), NEEDS YOU (`needsyou.ts`, lane N),
// RECENT (`recent.ts`, R3267) and the rows of the record (`record.ts`). An open message is a page of
// its own and takes the whole body (round 089 card 24 b). Each block is a
// function of the context below and returns markup; the overlay owns the
// press and the render. A control of a block carries a `data-act` that
// starts with `ib-`, and `press.ts` hands the press to the module that
// drew it.

import type { GameState } from '../../state';
import type { Tab } from '../overlay/tables';
import type { UIActions } from '../overlay/types';
import { needsYouHtml } from './needsyou';
import { recentHtml } from './recent';
import { openPageHtml, recordHeadHtml, recordHtml } from './record';
import { digestHtml, digestShown, sinceLeftHtml } from './sinceleft';

export interface InboxCtx {
  state: GameState;
  actions: UIActions;
  /** Draws the panel again; `force` skips the markup compare. */
  render(force?: boolean): void;
  /** Opens one tab of the dock at one of its pills, with the sheet. */
  openPanel(tab: Tab, sub: string): void;
  /** Closes the sheet on a telephone, so the map shows; a desktop ignores it. */
  collapse?(): void;
}

/** The whole INBOX page. ALL FIGURES › of SINCE YOU LEFT puts the DIGEST
 *  page in its place until ‹ BACK (inbox.md §7). */
export function inboxPage(c: InboxCtx): string {
  if (digestShown()) return digestHtml(c);
  const page = openPageHtml(c);
  if (page) return page;
  return recordHeadHtml(c) + sinceLeftHtml(c) + needsYouHtml(c) + recentHtml(c) + recordHtml(c);
}
